export default [
  {
    path: '/networkdiagram',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'NetworkdiagramInstructionList',
        component: () => import('./containers/InstructionListContainer'),
        children: [
          {
            path: 'create',
            name: 'NetworkdiagramInstructionCreate',
            component: () => import('./containers/InstructionCreateContainer'),
          },
        ],
      },
    ],
  },
]
